// Nav.jsx — warm editorial nav: transparent over hero, solid cream after
import React, { useState, useEffect } from "react";
import { Icon, Btn, Wordmark, Mark } from "./Primitives";
import { useIsMobile } from "./hooks";

export default function Nav({ route, onNav, cartCount, onCart }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  useEffect(() => {
    const f = () => setScrolled(window.scrollY > window.innerHeight * 0.72);
    window.addEventListener("scroll", f, { passive: true });
    f();
    return () => window.removeEventListener("scroll", f);
  }, []);
  const solid = route !== "home" || scrolled;
  // mobile home hero sits on a cream background, so use the light (ink) nav there too
  const lightBg = solid || (isMobile && route === "home");
  const links = [["Range", "shop"], ["Philosophy", "philosophy"], ["Our promise", "promise"]];
  const go = (r) => { onNav(r); setOpen(false); };
  const fg = lightBg ? "var(--ink)" : "#fff";

  return (
    <>
      <header style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 200, transition: "all .5s var(--ease)",
        background: solid ? "rgba(246,241,232,.86)" : "transparent",
        backdropFilter: solid ? "blur(14px) saturate(1.1)" : "none", WebkitBackdropFilter: solid ? "blur(14px)" : "none",
        borderBottom: solid ? "1px solid var(--line)" : "1px solid transparent" }}>
        <div style={{ maxWidth: 1480, margin: "0 auto", padding: "clamp(14px,2vw,22px) clamp(20px,4vw,56px)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div data-hover data-testid="nav-logo" onClick={() => go("home")} style={{ display: "flex", alignItems: "center", gap: 9, cursor: "pointer" }}>
            <Mark color={fg} size={20} />
            <Wordmark color={fg} size={25} />
          </div>

          <nav className="k-nav-links" style={{ gap: "clamp(22px,2.8vw,44px)", alignItems: "center" }}>
            {links.map(([l, r]) => (
              <a key={r} data-hover data-testid={`nav-link-${r}`} onClick={() => go(r)} className="k-link-underline" style={{ fontFamily: "var(--font-sans)", fontSize: 13.5, fontWeight: 500, letterSpacing: ".01em", color: route === r ? fg : (solid ? "var(--ink-2)" : "rgba(255,255,255,.85)"), transition: "color .3s", cursor: "pointer" }}>{l}</a>
            ))}
          </nav>

          <div style={{ display: "flex", alignItems: "center", gap: "clamp(16px,1.8vw,22px)" }}>
            <button data-hover data-testid="nav-cart-btn" onClick={() => onCart && onCart()} style={{ background: "none", border: "none", color: fg, cursor: "pointer", position: "relative", display: "flex" }}>
              <Icon name="handbag" size={21} />
              {cartCount > 0 && <span style={{ position: "absolute", top: -7, right: -8, minWidth: 16, height: 16, padding: "0 4px", borderRadius: 999, background: "var(--sage)", color: "#fff", fontFamily: "var(--font-sans)", fontSize: 9.5, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center" }}>{cartCount}</span>}
            </button>
            <button data-hover data-testid="nav-burger" className="k-burger" onClick={() => setOpen(true)} style={{ display: "none", background: "none", border: "none", color: fg, cursor: "pointer", padding: 6, alignItems: "center" }}><Icon name="list" size={24} /></button>
          </div>
        </div>
      </header>

      {/* mobile sheet */}
      <div style={{ position: "fixed", inset: 0, zIndex: 300, background: "var(--paper)", transform: open ? "translateY(0)" : "translateY(-100%)", transition: "transform .55s var(--ease)", display: "flex", flexDirection: "column", padding: "22px 24px 32px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 9 }}><Mark size={20} /><Wordmark size={24} /></div>
          <button data-hover data-testid="nav-mobile-close" onClick={() => setOpen(false)} style={{ background: "none", border: "none", color: "var(--ink)", cursor: "pointer", display: "flex" }}><Icon name="x" size={26} /></button>
        </div>
        <nav style={{ marginTop: "auto", marginBottom: "auto", display: "flex", flexDirection: "column", gap: 4 }}>
          {[["Home", "home"], ...links].map(([l, r]) => (
            <a key={r} data-testid={`nav-mobile-${r}`} onClick={() => go(r)} className="k-display" style={{ fontSize: "clamp(40px,11vw,56px)", color: "var(--ink)", padding: "7px 0", cursor: "pointer" }}>{l}</a>
          ))}
        </nav>
        <Btn variant="solid" size="lg" full onClick={() => go("shop")} testId="nav-mobile-cta">Shop the range</Btn>
      </div>
    </>
  );
}
